<script>
    export let isPrepago;
</script>

<div class="legals-sky-container">
    <p class="text-fs-15 text-center m-b-0">
        <span>Términos y condiciones</span>
        {#if isPrepago}
            <br />
            (1) Al contratar cualquiera de los paquetes de programación denominados:
            Sky Prepago Light, Sky Prepago, o Sky Prepago ViX Premium, y realizar
            el pago por concepto de habilitación del servicio, obtén sin costo adicional,
            4 recargas de 30 días del servicio de televisión restringida vía satélite,
            y la habilitación del primer equipo. Vigente al 31 de mayo 2025.
            <br />
            <br />
            Número de registro electrónico de tarifa en el IFT: Sky Prepago Light
            (30 días) 1674364 | Sky Prepago (30 días) 1674358 | Sky Prepago (14 días)
            1674362 | Sky Prepago ViX Premium: 1674363. Formatos Simplificados de
            información:
            <a
                href="https://sert.ift.org.mx/tarifasVE/publish/pdfs/FormatoSimplificado_1674364.pdf"
                target="_blank">Sky Prepago Ligth (30 días)</a
            >
            |
            <a
                href="https://sert.ift.org.mx/tarifasVE/publish/pdfs/FormatoSimplificado_1674358.pdf"
                target="_blank">Sky Prepago (30 días)</a
            >
            |
            <a
                href="https://sert.ift.org.mx/tarifasVE/publish/pdfs/FormatoSimplificado_1674362.pdf"
                target="_blank">Sky Prepago (14 días)</a
            >
            |
            <a
                href="https://sert.ift.org.mx/tarifasVE/publish/pdfs/FormatoSimplificado_1674363.pdf"
                target="_blank">Sky Prepago ViX Premium</a
            >
            <br />
            <br />
            Este paquete incluye sin costo los canales televisión abierta (radiodifundidos
            con cobertura de más del 50% del territorio nacional y de las Instituciones
            Públicas Federales), mismos que se retransmiten de forma gratuita, íntegra,
            no discriminatoria, y sin modificaciones. En cumplimiento a la reforma
            en materia de telecomunicaciones. Contacto Guía de programación.
        {:else}
            (1) Precio de promoción $369/mes durante los siguientes 6 meses al
            contratar el paquete Sky silver con 1 equipo (2) Precio de promoción
            $499/mes durante los siguientes 6 meses al contratar el paquete Sky
            gold con 1 equipo
        {/if}
    </p>
</div>

<style scoped>
    p {
        padding: 30px 0;
        line-height: 24px;
        font-size: 15px;
        font-weight: 500;
    }

    span {
        font-size: 24px;
    }
</style>
